import Delegate from "//legramme.com/cdn/shop/t/78/assets/ftdomdelegate.min.js?v=167457923630348017651773307050";

export class FaqSection extends HTMLElement {
    connectedCallback() {
      this.navContainer = this.querySelector('.faq__nav-container');
      // this.prevLink = this.element.querySelector('#previous-link');
      // this.nextLink = this.element.querySelector('#next-link');
      this.wrapperNav = this.querySelector('.faq__nav-wrapper');
      // this.tabActive = this.element.querySelector('.faq__nav-link.active');
      this.allTabsMenu = Array.from(this.querySelectorAll('.faq__nav-link'));
      this.allSeparators = Array.from(this.querySelectorAll('.faq__block'));
      //this.separatorsJson;
      this._setNavHeight();
  
      this._extractInfoFromJson();
      this._attachListeners();
      this._checkForMedia();
    }
  
    _extractInfoFromJson() {
      let jsonSeparators = this.querySelector('[data-separators-json]');
      if (!jsonSeparators) {
        return;
      }
  
      this.separatorsJson = JSON.parse(jsonSeparators.innerHTML);
  
      this._setFaqNavLink(0);
    }
  
    _attachListeners() {
      let that = this;
      new Delegate(this).on('click', '[data-action="toggle-menu"]', this._toggleNav.bind(this));
      new Delegate(this).on('click', '[data-action="active-link"]', this._activeLink.bind(this));
      new Delegate(this).on('click', '[data-action="paginate-item"]', this._paginateItem.bind(this));
      new Delegate(this).on('click', '[data-action="close-menu"]', this._closeNav.bind(this));
  
      if (window.location.hash !== '') {
        let item = document.querySelector('.faq__nav-link[href="'+window.location.hash+'"]');
        if (item) {
          item.click();
        }
      }
    }
  
    _toggleNav(event, target) {
      event.preventDefault();
      target.classList.toggle('active');
      this.querySelector('.faq__overlay').classList.toggle('active');
    }
  
    _closeNav(event, target) {
      if (event) event.preventDefault();
  
      // close nav bar
      this.querySelector('.faq__nav-header').classList.remove('active');
      this.querySelector('.faq__overlay').classList.remove('active');
    }
  
    _setNavHeight() {
      if (window.matchMedia("(max-width: 1023px)").matches) {
        let headerHeight = document.querySelector('.header').offsetHeight;
        if(this.wrapperNav.classList.contains('faq__nav-wrapper--full')){
          this.wrapperNav.style.height = window.innerHeight - (headerHeight) + 'px';
        }
      }
    }
  
    _activeLink(event, target) {
      event.preventDefault();
  
      // close nav bar
      this._closeNav();
  
      // Active separator
      let indexValue = parseInt(target.getAttribute('data-index'));
      this._revealIndexedItem(indexValue);
    }
  
    _revealIndexedItem(index) {
  
      for(const item of this.allSeparators) {
        item.classList.remove('active');
      }
  
      for(const item of this.allSeparators) {
        if (parseInt(item.getAttribute('data-index')) === parseInt(index)) {
          item.classList.add('active');
        }
      }
  
      this._setNavBarTitle(index);
      this._setFaqNavLink(index);
  
      setTimeout(function() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }, 100)
    }
  
    _setFaqNavLink(index) {
      // get current item
      let currentIndex = parseInt(index);
  
      // get the next item
      let nextIndex = currentIndex + 1;
      if (nextIndex > (this.allSeparators.length - 1)) {
        nextIndex = 0;
      }
      // set the next link
      let nextButton = document.querySelector('.faq__nav-pagination--next');
      if (nextButton) {
        nextButton.setAttribute('data-index', nextIndex.toString());
        nextButton.setAttribute('href', '#'+this.separatorsJson[nextIndex].href);
        nextButton.querySelector('p').innerText = this.separatorsJson[nextIndex].title;
      }
  
  
      // get the previous item
      let previousIndex = currentIndex - 1;
      if (previousIndex < 0) {
        previousIndex = (this.allSeparators.length - 1);
      }
      // set the previous link
      let previousButton = document.querySelector('.faq__nav-pagination--previous');
      if (previousButton) {
        previousButton.setAttribute('data-index', previousIndex.toString());
        previousButton.setAttribute('href', '#'+this.separatorsJson[previousIndex].href);
        previousButton.querySelector('p').innerText = this.separatorsJson[previousIndex].title;
      }
  
    }
  
    _setNavBarTitle(index) {
      // get the tag name
      let tabName = this.separatorsJson[index].title;
  
      // set tab name in header on mobile
      if (document.querySelector('.faq__nav-header-item')) {
        document.querySelector('.faq__nav-header-item').innerText = tabName;
      }
  
      // set tab active on desktop
      for (let i = 0; i < this.allTabsMenu.length; i++) {
        this.allTabsMenu[i].classList.remove('active');
      }
  
      this.allTabsMenu[index].classList.add('active');
  
    }
  
    _paginateItem(event, target) {
      event.preventDefault();
  
      let index = target.getAttribute('data-index');
      this._revealIndexedItem(index);
    }
  
    _checkForMedia() {
      let answers = document.querySelectorAll('.faq__answer');
      if (answers.length > 0) {
        for (let i = 0; i < answers.length; i++) {
          let body = answers[i].innerHTML;
  
          // check video
          const regexVideo = /\[video:(.*?)\]/g;
          let videos;
  
          while ((videos = regexVideo.exec(body)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (videos.index === regexVideo.lastIndex) {
              regexVideo.lastIndex++;
            }
  
            // The result can be accessed through the `m`-variable.
            videos.forEach((match, groupIndex) => {
              if (groupIndex === 1) {
                const subst = '<video class="faq__video" playsinline="playsinline" loop="loop" mute="true" autoplay="autoplay" muted="muted" preload="metadata">' +
                    '<source src="'+window.theme.fileUrl+match+'" type="video/mp4">' +
                  '</video>';
                body = body.replace(regexVideo, subst);
              }
            });
          }
  
  
          // check photo
          const regexPhoto = /\[image:(.*?)\]/g;
          let photos;
  
          while ((photos = regexPhoto.exec(body)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (photos.index === regexPhoto.lastIndex) {
              regexPhoto.lastIndex++;
            }
  
            // The result can be accessed through the `m`-variable.
            photos.forEach((match, groupIndex) => {
              if (groupIndex === 1) {
                const subst = '<img class="faq__image" src="'+window.theme.fileUrl+match+'"/>';
                body = body.replace(regexPhoto, subst);
              }
            });
          }
  
          answers[i].innerHTML = body;
        }
      }
    }
}
try {
  window.customElements.define('faq-section', FaqSection);
} catch(e) {}